import { CouponTypeCode, UserLevel } from "project-config/constants";
import CloseIcon from "@/assets/icons/topup/close";
import CheckIcon from "@/assets/icons/topup/fox-check";
import FoxNormal from "@/assets/images/fox-normal.png";
import FoxSliver from "@/assets/images/fox-silver.png";
import FoxGold from "@/assets/images/fox-gold.png";
import FoxPlatinum from "@/assets/images/fox-platinum.png";
import FoxDiamond from "@/assets/images/fox-diamond.png";

export interface AnimationVipDescProps {
  [key: number]: string;
}

export const AnimationVipDesc: AnimationVipDescProps = {
  [UserLevel.Normal]: "user_basic_level_normal_user",
  [UserLevel.Sliver]: "user_basic_level_silver_user",
  [UserLevel.Gold]: "user_basic_level_gold_user",
  [UserLevel.Platinum]: "user_basic_level_platinum_user",
  [UserLevel.Diamond]: "user_basic_level_diamond_user",
};

export enum BalanceWelfareType {
  balance = 1,
  UpGradeVip = 2,
}
export enum ExtraWelfareType {
  GPU = CouponTypeCode.GPU,
  CPU = CouponTypeCode.CPU,
  Universal = CouponTypeCode.Universal,
  LuckyDrawGift = 5,
}

export enum TipType {
  NotSatisfied = "Not satisfied",
  Satisfied = "Satisfied",
}

type TipTypeProp = {
  icon: React.ReactElement;
  preTitle: string;
  bgColor: string;
  titleColor: string;
};

export const CouponCodeTipList: Record<TipType, TipTypeProp> = {
  [TipType.NotSatisfied]: {
    icon: <CloseIcon />,
    preTitle: "fox_coupon_tip_not_satisfide",
    bgColor: "#2F3238",
    titleColor: "#FFFFFF",
  },
  [TipType.Satisfied]: {
    icon: <CheckIcon />,
    preTitle: "fox_coupon_tip_satisfide",
    bgColor: "rgba(251, 107, 74, 0.1)",
    titleColor: "#FB6B4A",
  },
};

export enum CouponType {
  GPU = 1,
  CPU,
  Universal,
}

export const FoxLevelContentMap = new Map([
  [
    UserLevel.Normal,
    {
      img: FoxNormal,
      color:
        "linear-gradient(270deg, #C2C2C2 0%, #7E7F82 45.31%, #B0B0AF 100%)",
    },
  ],
  [
    UserLevel.Sliver,
    {
      img: FoxSliver,
      color:
        "linear-gradient(257.94deg, #6785B3 6.48%, #5083CA 49.38%, #8CB7F5 94.03%)",
    },
  ],
  [
    UserLevel.Gold,
    {
      img: FoxGold,
      color:
        "linear-gradient(270deg, #DD7117 0%, #F0CC89 54.69%, #F6BB4C 100%)",
    },
  ],
  [
    UserLevel.Platinum,
    {
      img: FoxPlatinum,
      color:
        "linear-gradient(93.26deg, #D2CCFF 0%, #D6C2FF 49.36%, #92B3FF 91.13%)",
    },
  ],
  [
    UserLevel.Diamond,
    {
      img: FoxDiamond,
      color:
        "linear-gradient(270deg, #D3751D 0%, #ED8A4B 45.31%, #D2833C 100%)",
    },
  ],
]);
